module.exports = __webpack_public_path__ + "img/01-3.db81272f.png";